import e from "react";
import { Accessibility as t, Activity as n, AlarmSmoke as r, AlertCircle as i, AlertTriangle as a, Anchor as ee, Archive as te, Armchair as o, ArrowDown as s, ArrowLeft as c, ArrowLeftRight as l, ArrowRight as u, ArrowUp as d, ArrowUpRight as f, Baby as p, Backpack as m, BadgeCheck as h, BadgePercent as g, Ban as _, Banknote as v, BarChart as y, BarChart3 as b, Bath as x, Bed as S, BedDouble as C, Bell as w, BellRing as T, Bold as E, BookCheck as D, BookOpen as O, BookUser as k, Box as A, Briefcase as j, BriefcaseMedical as M, Building as N, Building2 as P, Calendar as F, CalendarCheck as I, CalendarClock as L, CalendarDays as R, CalendarMinus as z, CalendarOff as B, CalendarPlus as V, CalendarRange as H, CalendarSync as U, CalendarX as W, CalendarX2 as G, Camera as K, CarFront as q, Castle as J, Cctv as Y, Check as X, CheckCircle as Z, CheckCircle2 as Q, ChefHat as ne, ChevronDown as re, ChevronLeft as ie, ChevronRight as ae, ChevronUp as oe, Cigarette as se, Circle as ce, CircleCheck as le, CircleHelp as ue, CircleX as de, Clock as fe, Code as pe, Coffee as me, Columns as he, Compass as ge, ContactRound as _e, Copy as ve, CornerDownRight as ye, CreditCard as be, Crown as xe, Diamond as Se, Dices as Ce, DollarSign as we, DoorClosed as Te, Download as Ee, Droplet as De, Droplets as Oe, Dumbbell as ke, Edit2 as Ae, EllipsisVertical as je, ExternalLink as Me, Eye as Ne, Facebook as Pe, Fan as Fe, Fence as Ie, FileQuestion as Le, FileText as Re, Film as ze, FireExtinguisher as Be, Flame as Ve, FlameKindling as He, Flashlight as Ue, FlaskConical as We, Flower as Ge, Flower2 as Ke, Focus as qe, FolderOpen as Je, Footprints as Ye, Frown as Xe, Gamepad2 as Ze, Gauge as Qe, Gem as $e, GitBranch as et, Globe as tt, Grid2x2 as nt, GripVertical as rt, HandPlatter as it, Hash as at, Heading2 as ot, Heart as st, HeartHandshake as ct, HelpCircle as lt, History as ut, Home as dt, Hotel as ft, Image as pt, ImageOff as mt, ImagePlus as ht, Inbox as gt, Info as _t, Instagram as vt, Italic as yt, Key as bt, KeyRound as xt, KeySquare as St, Landmark as Ct, Languages as wt, Layers as Tt, Layout as Et, LayoutDashboard as Dt, LayoutGrid as Ot, LayoutPanelTop as kt, LayoutTemplate as At, LifeBuoy as jt, Lightbulb as Mt, Link as Nt, List as Pt, ListChecks as Ft, ListOrdered as It, Loader2 as Lt, LocateFixed as Rt, Lock as zt, LogIn as Bt, LogOut as $, Mail as Vt, MailPlus as Ht, Map as Ut, MapPin as Wt, Maximize as Gt, Megaphone as Kt, Meh as qt, MessageCircle as Jt, MessageSquare as Yt, MessagesSquare as Xt, Mic as Zt, Microwave as Qt, Milestone as $t, Minus as en, MonitorPlay as tn, Moon as nn, MoreHorizontal as rn, MoreVertical as an, Mountain as on, MousePointerClick as sn, Music as cn, Palmtree as ln, Paperclip as un, PartyPopper as dn, Pause as fn, PawPrint as pn, Pencil as mn, Percent as hn, PhoneCall as gn, PieChart as _n, PlaneTakeoff as vn, Play as yn, Plus as bn, PlusCircle as xn, QrCode as Sn, Quote as Cn, Radio as wn, Receipt as Tn, ReceiptText as En, RefreshCw as Dn, Refrigerator as On, Rocket as kn, RotateCw as An, Rss as jn, Save as Mn, Scale as Nn, ScanFace as Pn, ScrollText as Fn, Search as In, SearchX as Ln, Send as Rn, Settings as zn, Share2 as Bn, Shield as Vn, ShieldAlert as Hn, ShieldCheck as Un, Shirt as Wn, ShoppingBag as Gn, ShoppingCart as Kn, Shuffle as qn, Siren as Jn, SlidersHorizontal as Yn, Smartphone as Xn, Smile as Zn, Snowflake as Qn, Sofa as $n, Sparkles as er, Speaker as tr, SprayCan as nr, Square as rr, Star as ir, StarHalf as ar, StickyNote as or, Sun as sr, Tag as cr, Tags as lr, Tent as ur, Terminal as dr, Thermometer as fr, ThermometerSun as pr, ThumbsDown as mr, ThumbsUp as hr, Ticket as gr, TicketPercent as _r, Trash as vr, Trash2 as yr, TreePine as br, Trees as xr, TrendingDown as Sr, TrendingUp as Cr, Trophy as wr, Tv as Tr, Twitter as Er, Undo2 as Dr, Upload as Or, User as kr, UserCheck as Ar, UserCircle as jr, UserMinus as Mr, UserPlus as Nr, Users as Pr, Utensils as Fr, UtensilsCrossed as Ir, Volume2 as Lr, VolumeX as Rr, Wallet as zr, WashingMachine as Br, Waves as Vr, Webhook as Hr, Wifi as Ur, Wind as Wr, Wrench as Gr, X as Kr, XCircle as qr, Zap as Jr, ZoomIn as Yr, ZoomOut as Xr } from "lucide-react";
//#region src/components/Icons/Icons.ts
var Zr = () => e.createElement("linearGradient", {
	id: "ai-gradient",
	x1: "0%",
	y1: "0%",
	x2: "100%",
	y2: "100%"
}, e.createElement("stop", {
	offset: "0%",
	stopColor: "#ff4c4c"
}, e.createElement("animate", {
	attributeName: "stop-color",
	values: "#ff4c4c;#c06c84;#6c5b7b;#3b82f6;#00d2ff;#ff4c4c",
	dur: "6s",
	repeatCount: "indefinite"
})), e.createElement("stop", {
	offset: "25%",
	stopColor: "#c06c84"
}, e.createElement("animate", {
	attributeName: "stop-color",
	values: "#c06c84;#6c5b7b;#3b82f6;#00d2ff;#ff4c4c;#c06c84",
	dur: "6s",
	repeatCount: "indefinite"
})), e.createElement("stop", {
	offset: "50%",
	stopColor: "#6c5b7b"
}, e.createElement("animate", {
	attributeName: "stop-color",
	values: "#6c5b7b;#3b82f6;#00d2ff;#ff4c4c;#c06c84;#6c5b7b",
	dur: "6s",
	repeatCount: "indefinite"
})), e.createElement("stop", {
	offset: "75%",
	stopColor: "#3b82f6"
}, e.createElement("animate", {
	attributeName: "stop-color",
	values: "#3b82f6;#00d2ff;#ff4c4c;#c06c84;#6c5b7b;#3b82f6",
	dur: "6s",
	repeatCount: "indefinite"
})), e.createElement("stop", {
	offset: "100%",
	stopColor: "#00d2ff"
}, e.createElement("animate", {
	attributeName: "stop-color",
	values: "#00d2ff;#ff4c4c;#c06c84;#6c5b7b;#3b82f6;#00d2ff",
	dur: "6s",
	repeatCount: "indefinite"
}))), Qr = new Proxy({
	Accessibility: t,
	Activity: n,
	AlarmSmoke: r,
	AlertCircle: i,
	AlertTriangle: a,
	Anchor: ee,
	Archive: te,
	Armchair: o,
	ArrowDown: s,
	ArrowLeft: c,
	ArrowLeftRight: l,
	ArrowRight: u,
	ArrowUp: d,
	ArrowUpRight: f,
	Baby: p,
	Backpack: m,
	BadgeCheck: h,
	BadgePercent: g,
	Ban: _,
	Banknote: v,
	BarChart: y,
	BarChart3: b,
	Bath: x,
	Bed: S,
	BedDouble: C,
	Bell: w,
	BellRing: T,
	Bold: E,
	BookCheck: D,
	BookOpen: O,
	BookUser: k,
	Box: A,
	Briefcase: j,
	BriefcaseMedical: M,
	Building: N,
	Building2: P,
	Calendar: F,
	CalendarCheck: I,
	CalendarClock: L,
	CalendarDays: R,
	CalendarMinus: z,
	CalendarOff: B,
	CalendarPlus: V,
	CalendarRange: H,
	CalendarSync: U,
	CalendarX: W,
	CalendarX2: G,
	Camera: K,
	Cctv: Y,
	Cigarette: se,
	CarFront: q,
	Castle: J,
	Check: X,
	CheckCircle: Z,
	CheckCircle2: Q,
	ChefHat: ne,
	ChevronDown: re,
	ChevronLeft: ie,
	ChevronRight: ae,
	ChevronUp: oe,
	Circle: ce,
	CircleCheck: le,
	CircleHelp: ue,
	CircleX: de,
	Clock: fe,
	Code: pe,
	DoorClosed: Te,
	ExternalLink: Me,
	Fence: Ie,
	Flashlight: Ue,
	FlaskConical: We,
	Grid2x2: nt,
	Terminal: dr,
	Webhook: Hr,
	Coffee: me,
	Columns: he,
	Compass: ge,
	ContactRound: _e,
	Copy: ve,
	CornerDownRight: ye,
	CreditCard: be,
	Crown: xe,
	Diamond: Se,
	Dices: Ce,
	DollarSign: we,
	Download: Ee,
	Droplet: De,
	Droplets: Oe,
	Dumbbell: ke,
	Edit2: Ae,
	EllipsisVertical: je,
	Eye: Ne,
	Facebook: Pe,
	Fan: Fe,
	FileQuestion: Le,
	FileText: Re,
	Film: ze,
	FireExtinguisher: Be,
	Flame: Ve,
	FlameKindling: He,
	Flower: Ge,
	Flower2: Ke,
	Focus: qe,
	FolderOpen: Je,
	Footprints: Ye,
	Frown: Xe,
	Gamepad2: Ze,
	Gauge: Qe,
	Gem: $e,
	GitBranch: et,
	Globe: tt,
	GripVertical: rt,
	HandPlatter: it,
	Hash: at,
	Heading2: ot,
	Heart: st,
	HeartHandshake: ct,
	HelpCircle: lt,
	History: ut,
	Home: dt,
	Hotel: ft,
	Image: pt,
	ImageOff: mt,
	ImagePlus: ht,
	Inbox: gt,
	Info: _t,
	Instagram: vt,
	Italic: yt,
	Key: bt,
	KeyRound: xt,
	KeySquare: St,
	Landmark: Ct,
	Languages: wt,
	Layers: Tt,
	Layout: Et,
	Lightbulb: Mt,
	LayoutDashboard: Dt,
	LayoutGrid: Ot,
	LayoutPanelTop: kt,
	LayoutTemplate: At,
	LifeBuoy: jt,
	Link: Nt,
	List: Pt,
	ListChecks: Ft,
	ListOrdered: It,
	Loader2: Lt,
	LocateFixed: Rt,
	Lock: zt,
	LogIn: Bt,
	LogOut: $,
	Mail: Vt,
	MailPlus: Ht,
	Map: Ut,
	MapPin: Wt,
	Maximize: Gt,
	Megaphone: Kt,
	Meh: qt,
	MessageCircle: Jt,
	MessageSquare: Yt,
	MessagesSquare: Xt,
	Mic: Zt,
	Microwave: Qt,
	Milestone: $t,
	Minus: en,
	MonitorPlay: tn,
	Moon: nn,
	MoreHorizontal: rn,
	MoreVertical: an,
	Mountain: on,
	MousePointerClick: sn,
	Music: cn,
	Palmtree: ln,
	Paperclip: un,
	PartyPopper: dn,
	PawPrint: pn,
	Pause: fn,
	Pencil: mn,
	Percent: hn,
	PhoneCall: gn,
	PieChart: _n,
	PlaneTakeoff: vn,
	Play: yn,
	Plus: bn,
	PlusCircle: xn,
	QrCode: Sn,
	Quote: Cn,
	Radio: wn,
	Receipt: Tn,
	ReceiptText: En,
	RefreshCw: Dn,
	Refrigerator: On,
	Rocket: kn,
	RotateCw: An,
	Rss: jn,
	Save: Mn,
	Scale: Nn,
	ScanFace: Pn,
	Search: In,
	SearchX: Ln,
	Send: Rn,
	Settings: zn,
	ScrollText: Fn,
	Share2: Bn,
	Shield: Vn,
	ShieldAlert: Hn,
	ShieldCheck: Un,
	Shirt: Wn,
	ShoppingBag: Gn,
	ShoppingCart: Kn,
	Shuffle: qn,
	Siren: Jn,
	SlidersHorizontal: Yn,
	Smartphone: Xn,
	Smile: Zn,
	Snowflake: Qn,
	Sofa: $n,
	Sparkles: er,
	Speaker: tr,
	SprayCan: nr,
	Square: rr,
	Star: ir,
	StarHalf: ar,
	StickyNote: or,
	Sun: sr,
	Tag: cr,
	Tags: lr,
	Tent: ur,
	Thermometer: fr,
	ThermometerSun: pr,
	ThumbsDown: mr,
	ThumbsUp: hr,
	Ticket: gr,
	TicketPercent: _r,
	Trash: vr,
	Trash2: yr,
	TreePine: br,
	Trees: xr,
	TrendingDown: Sr,
	TrendingUp: Cr,
	Trophy: wr,
	Tv: Tr,
	Twitter: Er,
	Undo2: Dr,
	Upload: Or,
	User: kr,
	UserCheck: Ar,
	UserCircle: jr,
	UserMinus: Mr,
	UserPlus: Nr,
	Users: Pr,
	Volume2: Lr,
	VolumeX: Rr,
	Utensils: Fr,
	UtensilsCrossed: Ir,
	Wallet: zr,
	WashingMachine: Br,
	Waves: Vr,
	Wifi: Ur,
	Wind: Wr,
	Wrench: Gr,
	X: Kr,
	XCircle: qr,
	Zap: Jr,
	ZoomIn: Yr,
	ZoomOut: Xr
}, { get(t, n) {
	let r = t[n];
	if (typeof n == "string" && /^[A-Z]/.test(n) && (typeof r == "function" || typeof r == "object")) {
		let t = e.forwardRef(({ ai: t, children: n, ...i }, a) => t ? e.createElement(r, {
			ref: a,
			...i,
			stroke: "url(#ai-gradient)"
		}, e.createElement(Zr, null), n) : e.createElement(r, {
			ref: a,
			...i
		}, n));
		return t.displayName = `Icons.${n}`, t;
	}
	return r;
} });
//#endregion
export { Qr as Icons };
